import { Notification as ServerNotification } from '../../../common/model/WK.Ladon.Cms.Read.Queries.Notification.Model.Notification';
import { FilterDirectory } from '../../../common/model/WK.Ladon.Cms.Read.Queries.User.Model.FilterDirectory';
import { Moment } from 'moment/moment';
import { v4 as Guid } from 'uuid';
import { SessionInfo } from '../../../common/model/WK.Ladon.Cms.Api.Model.Results.Authorization.SessionInfo';
import { User } from '../../../common/model/WK.Ladon.Cms.Read.Queries.User.Model.User';

export interface UserState {
    personalSettings: PersonalSettings;
    personalSettingsErrorCode: number,
    user: User;
    notifications: NotificationState;
    showForbiddenInfo: boolean;
    sessionInfo: SessionInfo;
}

export interface PersonalSettings {
    filterDirectories: FilterDirectory[];
    timestamp?: Moment;
    selectedDirectoryId?: Guid;
}

export enum NotificationConnectionState {
    connected = 1,
    disconnected = 2,
    pending = 3
}

export interface NotificationState {
    connectionState: NotificationConnectionState;
    list: ReadonlyArray<Notification>;
}

export interface Notification extends ServerNotification {
     uuid: string;
     read: boolean;
 }

